import React from 'react'
import EventEmitterExResident from '../../shared/pageBaseComponents/EventEmitterExResident'
import RRFFReserveAvailabilityViewOvernightFacility from './RRFFReserveAvailabilityViewOvernightFacility'
import RRFFReserveAvailabilityViewDurationFacility from './RRFFReserveAvailabilityViewDurationFacility'
import {Nullable} from '../../../app/TypeHelpers'
import ReserveAvailabilityOvernight from '../ReserveAvailabilityOvernight'
import ReserveAvailabilityDuration from '../ReserveAvailabilityDuration'
import ReservationsRepository from '../ReservationsRepository'
import moment from 'moment'
import {NavigateFunction} from 'react-router-dom'

interface Props {
    targetDate: string

    condominiumCd: string
    facilityId: number
    facilityName: string
    reservationId: Nullable<number>
    stayAvailable: Nullable<boolean>
    reservationsRepo: ReservationsRepository
    eventEmitter: EventEmitterExResident

    onChangeDate: (date: string) => void
    onChangeReserveAvailabilityOvernight: (data: ReserveAvailabilityOvernight) => void
    onChangeReserveAvailabilityDuration: (data: ReserveAvailabilityDuration) => void

    navigate: NavigateFunction
    currentDateTime: moment.Moment
    holidays: string[]
}

const RRFFReserveAvailabilityView: React.FC<Props> = props => {
    if (props.stayAvailable === null) {
        return null
    }
    return (
        props.stayAvailable
            ? <RRFFReserveAvailabilityViewOvernightFacility
                targetDate={props.targetDate}
                condominiumCd={props.condominiumCd}
                facilityId={props.facilityId}
                facilityName={props.facilityName}
                reservationId={props.reservationId}
                reservationsRepo={props.reservationsRepo}
                eventEmitter={props.eventEmitter}
                onChangeDate={props.onChangeDate}
                onChangeReserveAvailabilitiesOvernight={props.onChangeReserveAvailabilityOvernight}
                navigate={props.navigate}
                currentDateTime={props.currentDateTime}
                holidays={props.holidays}
            />
            : <RRFFReserveAvailabilityViewDurationFacility
                targetDate={props.targetDate}
                condominiumCd={props.condominiumCd}
                facilityId={props.facilityId}
                facilityName={props.facilityName}
                reservationId={props.reservationId}
                reservationsRepo={props.reservationsRepo}
                eventEmitter={props.eventEmitter}
                onChangeDate={props.onChangeDate}
                onChangeReserveAvailabilityDuration={props.onChangeReserveAvailabilityDuration}
                navigate={props.navigate}
                currentDateTime={props.currentDateTime}
                holidays={props.holidays}
            />
    )
}

RRFFReserveAvailabilityView.displayName = 'RRFFReserveAvailabilityView'
export default RRFFReserveAvailabilityView
